// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__dWlu+","inactive":"Tab_inactive__ohjdM","disabled":"Tab_disabled__+d0xp"};